import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Drawer, Flex, Typography } from '@robinpowered/ui-kit';
import Close from '@robinpowered/ui-kit-icons/Close';
import { ProfileDetailsCardContainer } from './ProfileDetailsCard';

type PeopleProfileSidebarProps = {
  onClose: () => void;
  userId?: string;
};

export const PeopleProfileSidebar = ({
  onClose,
  userId,
}: PeopleProfileSidebarProps): JSX.Element => {
  const { t } = useTranslation('peopleProfileSidebar');

  return (
    <Drawer
      aria-label={t('title')}
      closable={false}
      extra={
        <Button
          aria-label={t('closeButtonLabel')}
          icon={<Close />}
          onClick={onClose}
          type="text"
        />
      }
      mask={false}
      onClose={onClose}
      open
      placement="right"
      title={
        <Typography.Title level={4} style={{ margin: 0 }}>
          {t('title')}
        </Typography.Title>
      }
      width={340}
      zIndex={1100}
      styles={{
        body: {
          padding: 0,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <SidebarBody vertical>
        {userId && <ProfileDetailsCardContainer userId={userId} />}
      </SidebarBody>
    </Drawer>
  );
};

const SidebarBody = styled(Flex)`
  min-height: 100%;
`;
